/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompetitionBrowseFacetCount
 */
export interface CompetitionBrowseFacetCount {
    /**
     * The facet value — a CompetitionType, a NormalizedCompetitionStatus, or a game ObjectId depending on which facet.
     * @type {string}
     * @memberof CompetitionBrowseFacetCount
     */
    value: string;
    /**
     * How many competitions would be in the feed if this value were selected.
     * @type {number}
     * @memberof CompetitionBrowseFacetCount
     */
    count: number;
}

/**
 * Check if a given object implements the CompetitionBrowseFacetCount interface.
 */
export function instanceOfCompetitionBrowseFacetCount(value: object): value is CompetitionBrowseFacetCount {
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('count' in value) || value['count'] === undefined) return false;
    return true;
}

export function CompetitionBrowseFacetCountFromJSON(json: any): CompetitionBrowseFacetCount {
    return CompetitionBrowseFacetCountFromJSONTyped(json, false);
}

export function CompetitionBrowseFacetCountFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompetitionBrowseFacetCount {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'],
        'count': json['count'],
    };
}

export function CompetitionBrowseFacetCountToJSON(json: any): CompetitionBrowseFacetCount {
    return CompetitionBrowseFacetCountToJSONTyped(json, false);
}

export function CompetitionBrowseFacetCountToJSONTyped(value?: CompetitionBrowseFacetCount | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'value': value['value'],
        'count': value['count'],
    };
}

